import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackSkillPublishedToWorkspace.meta';

export type UseTrackSkillPublishedToWorkspaceParams = {
  skill_id: string;
};

export const useTrackSkillPublishedToWorkspace = () => {
  const { track } = useAnalyticsUtilities();

  const trackSkillPublishedToWorkspace = useCallback(
    (params: UseTrackSkillPublishedToWorkspaceParams) => {
      track(META.name, params);
    },
    [track],
  );

  return { trackSkillPublishedToWorkspace };
};
